import { type BooleanField } from '@/types/schema/fields/BooleanField';
import i18n from '@/i18n';

export function getBooleanFieldLabel(fieldFormat: BooleanField['format'], value: boolean) {
  const fallback = value
    ? i18n.t('attributes.field_labels.boolean.yes')
    : i18n.t('attributes.field_labels.boolean.no');

  if (!fieldFormat) {
    return fallback;
  }

  if (fieldFormat.format === 'true_false') {
    return value
      ? i18n.t('attributes.field_labels.boolean.true')
      : i18n.t('attributes.field_labels.boolean.false');
  }

  if (fieldFormat.format === 'on_off') {
    return value
      ? i18n.t('attributes.field_labels.boolean.on')
      : i18n.t('attributes.field_labels.boolean.off');
  }

  return fallback;
}
